import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/** Unauthenticated client for public portal view */
const publicApi = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

export const portalService = {
  createInvite: async (data) => {
    const response = await api.post('/portal/invites', data);
    return response.data;
  },
  listInvites: async (patientId) => {
    const response = await api.get(`/portal/invites/patient/${patientId}`);
    return response.data;
  },
  revokeInvite: async (id) => {
    const response = await api.patch(`/portal/invites/${id}/revoke`);
    return response.data;
  },
  view: async (token) => {
    const response = await publicApi.get(`/portal/view/${token}`);
    return response.data;
  },
  submitIntake: async (token, data) => {
    const response = await publicApi.post(`/portal/view/${token}/intake`, data);
    return response.data;
  },
  sendMessage: async (token, data) => {
    const response = await publicApi.post(`/portal/view/${token}/messages`, data);
    return response.data;
  },
  requestAppointment: async (token, data) => {
    const response = await publicApi.post(`/portal/view/${token}/appointment-request`, data);
    return response.data;
  },
  confirmInvoicePayment: async (sessionId) => {
    const response = await publicApi.post('/portal/invoice-payment/confirm', { sessionId });
    return response.data;
  },
  sendClinicianMessage: async (data) => {
    const response = await api.post('/portal/messages', data);
    return response.data;
  },
  createClientAccount: async (data) => {
    const response = await api.post('/portal/client-accounts', data);
    return response.data;
  },
};

export default portalService;
